import { PageHeaderStatic, WidgetIcon } from '@procureai/ui-mui';

import { BaseDomainType } from '~/common/types';
import { DomainIcon } from '~/components/DomainIcon/DomainIcon';
import { InternalToolsPageTitle } from '~/components/InternalToolsPageTitle/InternalToolsPageTitle';
import { PageLayout } from '~/components/PageLayout/PageLayout';

export const InternalTools = () => {
  return (
    <PageLayout
      fullHeight
      renderHeader={
        <PageHeaderStatic
          title={<InternalToolsPageTitle />}
          maxWidth={false}
          icon={<WidgetIcon icon={<DomainIcon domain={BaseDomainType.INTERNAL_TOOLS} />} />}
        />
      }
    ></PageLayout>
  );
};
